import styled from '@emotion/styled';

export const tabCelWidth = 200;

export const TabsContainer = styled('div')(({ theme }) => ({
  paddingTop: '4px',
  minHeight: '38px',
  display: 'flex',
  minWidth: 'calc(100% - 35px)',
  flexWrap: 'no-wrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  whiteSpace: 'nowrap',
}));

export const TabItem = styled('div', {
  shouldForwardProp: prop => prop !== 'selected',
})(({ theme, selected }) => ({
  'position': 'relative',
  'display': 'inline-flex',
  'alignItems': 'center',
  'justifyContent': 'space-between',
  'padding': '0 12px 0 6px',
  'height': '36px',
  'minWidth': `${tabCelWidth}px`,
  'maxWidth': `${tabCelWidth}px`,
  'backgroundColor': selected ? theme.palette.background.paper : 'transparent',
  'color': selected ? theme.palette.text.primary : theme.palette.text.secondary,
  'fontSize': '0.8125rem',
  'fontWeight': selected ? 500 : 400,
  'cursor': 'pointer',
  'transition': 'all 0.2s ease',
  'whiteSpace': 'nowrap',
  'overflow': 'hidden',
  'textOverflow': 'ellipsis',
  'borderBottom': selected
    ? `2px solid ${theme.palette.primary.main}`
    : '2px solid transparent',
  '&:hover': {
    'backgroundColor': !selected
      ? theme.palette.action.hover
      : theme.palette.background.paper,
    'color': theme.palette.text.primary,
    '& .MuiSvgIcon-root': {
      opacity: 1,
    },
  },
  '& .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '4px',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
    transition: 'opacity 0.1s, color 0.1s, scale 0.1s',
    marginRight: 'auto',
  },
  '& .MuiSvgIcon-root:hover': {
    scale: 1.1,
  },
  '& .close-icon:hover': {
    color: theme.palette.error.main,
  },
  '& .refresh-icon:hover': {
    color: theme.palette.primary.main,
  },
  ...(selected && {
    boxShadow: '0 -2px 8px rgba(0,0,0,0.03), 0 -1px 0 rgba(0,0,0,0.05)',
  }),
}));

export const TabLabel = styled('span')({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'right',
});

export const NavMenuItem = styled('div', {
  shouldForwardProp: prop => prop !== 'selected',
})(({ theme, selected }) => ({
  'display': 'flex',
  'flexDirection': 'row-reverse',
  'alignItems': 'center',
  'height': '32px',
  'padding': '0 8px',
  'borderRadius': '2px',
  'backgroundColor': selected ? theme.palette.background.paper : 'transparent',
  'color': selected ? theme.palette.text.primary : theme.palette.text.secondary,
  'fontSize': '0.8125rem',
  'fontWeight': selected ? 500 : 400,
  'cursor': 'pointer',
  'transition': 'all 0.2s ease',
  'borderRight': selected
    ? `2px solid ${theme.palette.primary.main}`
    : '2px solid transparent',
  '&:hover': {
    backgroundColor: !selected
      ? theme.palette.action.hover
      : theme.palette.action.selected,
    color: theme.palette.text.primary,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
    transition: 'opacity 0.1s, color 0.1s, scale 0.1s',
    marginRight: 'auto',
  },
  '& .MuiSvgIcon-root:hover': {
    scale: 1.1,
  },
  '& .close-icon:hover': {
    color: theme.palette.error.main,
  },
  '& .refresh-icon:hover': {
    color: theme.palette.primary.main,
  },
}));
